import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { Children, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHits, useInstantSearch } from "react-instantsearch-hooks";

import {
  Alert,
  Box,
  Button,
  H,
  handleComponentsProp,
  Section,
  useThemeProps,
} from "../../wsui/base";

import DefaultHitComponent from "./HitController.jsx";
import HitsController from "./HitsController.jsx";

// import { useTranslation } from "react-i18next";

function RenderIfChildren({ as: Component = "div", children, ...restProps }) {
  if (!Children.count(children)) {
    return null;
  }
  return <Component {...restProps}>{children}</Component>;
}

const DefaultEmptyResultsWrapper = styled(RenderIfChildren)``;

const DefaultEmptyRequestWrapper = styled(RenderIfChildren)``;

const DefaultErrorWrapper = styled(RenderIfChildren)``;

export default function Hits(props) {
  const { t } = useTranslation();
  props = useThemeProps({ props, name: "AlgoliaHits" });
  let {
    hits,
    // results,
    // sendEvent,
  } = useHits(props);
  const {
    hitComponent = DefaultHitComponent,
    children,
    emptyRequestMessage,
    loadingMessage = (
      <Alert
        severity="info"
        description={t(`wsui.algolia.loadingResultsMessage`)}
      />
    ),
    emptyResultsMessage = (
      <Alert
        severity="info"
        description={t(`wsui.algolia.emptyResultsMessage`)}
      />
    ),
    components,
    ...restProps
  } = props;
  let { EmptyResultsWrapper, EmptyRequestWrapper, ErrorWrapper } =
    handleComponentsProp(components, {
      EmptyResultsWrapper: DefaultEmptyResultsWrapper,
      EmptyRequestWrapper: DefaultEmptyRequestWrapper,
      ErrorWrapper: DefaultErrorWrapper,
    });
  // const { t } = useTranslation();

  // if (typeof children === "function") {
  //   return children({
  //     hits,
  //     results,
  //     sendEvent,
  //     hitComponent: Hit,
  //     ...restProps,
  //   });
  // }
  const { results, error, status, refresh } = useInstantSearch();

  // TODO: Move this logic to a separate component or hook
  const [consecutiveErrors, setConsecutiveErrors] = useState(0);
  useEffect(() => {
    if (status === "error") {
      if (consecutiveErrors < 2) {
        // eslint-disable-next-line no-console
        console.log("Refreshing due to error");
        refresh();
      }
      setConsecutiveErrors((prev) => prev + 1);
    } else if (status === "idle") {
      setConsecutiveErrors(0);
    }
  }, [status]);

  if (children) {
    throw new Error(
      "Children not supported for Hits component. Use hitComponent prop instead.",
    );
  }

  if (status === "error") {
    return (
      <ErrorWrapper {...restProps}>
        <Box>
          <H>{t("wsui.algolia.error")}</H>
          <Section>
            <p>
              <Button onClick={() => refresh()} variant="primary">
                {t("wsui.algolia.retry")}
              </Button>
            </p>
            <p
              css={css`
                opacity: 0.5;
              `}
            >
              {t("wsui.algolia.errorCode")}: {error?.name}:{" "}
              {error?.transporterStackTrace?.[0]?.response?.content}
            </p>
          </Section>
        </Box>
      </ErrorWrapper>
    );
  }

  if (status === "loading" || status === "stalled") {
    return (
      <EmptyResultsWrapper {...restProps}>{loadingMessage}</EmptyResultsWrapper>
    );
  }

  if (!results || results.__isArtificial) {
    return null;
  }

  if (!hits?.length) {
    if (results.intercepted) {
      return (
        <EmptyRequestWrapper {...restProps}>
          {emptyRequestMessage}
        </EmptyRequestWrapper>
      );
    }
    return (
      <EmptyResultsWrapper {...restProps}>
        {emptyResultsMessage}
      </EmptyResultsWrapper>
    );
  }

  return (
    <HitsController hitComponent={hitComponent} hits={hits} {...restProps} />
  );
}
